// Ensure window.Eurus exists
window.Eurus = window.Eurus || {};
window.Eurus.loadedScript = window.Eurus.loadedScript || new Set();

if (!window.Eurus.loadedScript.has('about-bryan-timeline.js')) {
  window.Eurus.loadedScript.add('about-bryan-timeline.js');

  const initTimeline = function() {
    const container = document.querySelector('.about-bryan');
    if (!container) {
      console.log('About Bryan container not found');
      return;
    }

    const snapshotSections = container.querySelectorAll('.snapshot-section');
    
    if (snapshotSections.length === 0) {
      console.log('No snapshot sections found');
      return;
    }

    console.log('Initializing parallax with', snapshotSections.length, 'sections');

      // Fade in a section
      function fadeInSection(section) {
        const image = section.querySelector('.left img');
        const text = section.querySelector('.right');
        
        if (image && image.style.opacity !== '1') {
          image.style.transition = 'opacity 0.8s ease, transform 0.8s ease';
          requestAnimationFrame(() => {
            image.style.opacity = '1';
            image.style.transform = 'translateY(0)';
          });
        }
        
        if (text && text.style.opacity !== '1') {
          text.style.transition = 'opacity 0.8s ease 0.2s, transform 0.8s ease 0.2s';
          requestAnimationFrame(() => {
            setTimeout(() => {
              text.style.opacity = '1';
              text.style.transform = 'translateY(0)';
            }, 200);
          });
        }
      }

      // Setup Intersection Observer for fade-in effects
      function setupFadeInObserver() {
        // Show first section immediately
        if (snapshotSections.length > 0) {
          fadeInSection(snapshotSections[0], 0);
        }

        const observerOptions = {
          root: null,
          rootMargin: '0px 0px -20% 0px',
          threshold: 0.1
        };

        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const section = entry.target;
              fadeInSection(section);
            }
          });
        }, observerOptions);

        snapshotSections.forEach((section, index) => {
          // Check if section is already in view
          const rect = section.getBoundingClientRect();
          const isInView = rect.top < window.innerHeight && rect.bottom > 0;
          
          if (isInView && index > 0) {
            // Already visible, fade in immediately
            fadeInSection(section);
          }
          
          observer.observe(section);
        });
      }

      // Setup parallax effect for images
      function setupParallax() {
        const isMobile = window.innerWidth < 768;
        if (isMobile) return; // Skip parallax on mobile

        snapshotSections.forEach((section) => {
          const image = section.querySelector('.left img');
          if (!image) return;

          const observerOptions = {
            root: null,
            rootMargin: '0px',
            threshold: [0, 0.25, 0.5, 0.75, 1]
          };

          const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                const rect = entry.boundingClientRect;
                const scrollProgress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
                const parallaxOffset = scrollProgress * 30; // Adjust parallax intensity
                
                image.style.transform = `translate3d(0, ${parallaxOffset}px, 0)`;
                image.style.willChange = 'transform';
              }
            });
          }, observerOptions);

          observer.observe(section);
        });
      }

    // Initialize after a short delay to ensure layout is ready
    setTimeout(() => {
      setupFadeInObserver();
      setupParallax();
    }, 100);
  }

  // Try to initialize immediately if DOM is ready, otherwise wait
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTimeline);
  } else {
    // DOM is already ready
    requestAnimationFrame(() => {
      initTimeline();
    });
  }
}
